import { render, staticRenderFns } from "./CasePhysicalAssessments.vue?vue&type=template&id=9a1ca048&scoped=true&"
import script from "./CasePhysicalAssessments.vue?vue&type=script&lang=js&"
export * from "./CasePhysicalAssessments.vue?vue&type=script&lang=js&"
import style0 from "./CasePhysicalAssessments.vue?vue&type=style&index=0&id=9a1ca048&scoped=true&lang=css&"
import style1 from "./CasePhysicalAssessments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1ca048",
  null
  
)

export default component.exports